import { APPOINTMENT_TYPES } from '@shared/data-access'

const isReadOnlyForRs = (appointmentType, isEdit) => {
  // Si NO es edición (es creación de nueva cita), los referentes sociales SÍ pueden crear
  if (!isEdit) {
    return false
  }

  // OPs pueden editar SOLO: Seguimiento Anual y Plan de Prevención (genérico de campaña)
  const editableTypesForOps = [
    APPOINTMENT_TYPES.GENERIC_ANALYSIS, // Plan de Prevención
    APPOINTMENT_TYPES.FOLLOW_UP_ANALYSIS, // Seguimiento Anual (online)
    APPOINTMENT_TYPES.FOLLOW_UP_ANALYSIS_CALL, // Seguimiento Anual (llamada)
    APPOINTMENT_TYPES.INITIAL_ANALYSIS,
  ]

  // Si el tipo de cita es editable para OPs, permitir edición
  if (editableTypesForOps.some((type) => type === appointmentType)) {
    return false
  }

  // Referentes sociales NO pueden editar otros tipos de citas ni tiempos de transporte
  // Solo los coordinadores pueden hacerlo
  const readOnlyTypesForRs = [
    APPOINTMENT_TYPES.INITIAL_REPORT,
    APPOINTMENT_TYPES.INITIAL_REPORT_FACE_TO_FACE,
    APPOINTMENT_TYPES.SERVICE_APPOINTMENT,
    APPOINTMENT_TYPES.MONITORING_REPORT,
    APPOINTMENT_TYPES.CONSULTATION,
    APPOINTMENT_TYPES.WELCOME_CALL,
    APPOINTMENT_TYPES.ABSENCES,
    'TRAVEL_TIME',
  ]

  return readOnlyTypesForRs.some((type) => type === appointmentType)
}

const isReadOnlyForCoordinator = (appointmentType) => {
  // Los coordinadores pueden editar todo
  const readOnlyTypesForCoordinator = []

  return readOnlyTypesForCoordinator.some((type) => type === appointmentType)
}

export const getIsReadOnly = ({
  isReadOnly,
  isCoordinator,
  appointmentType,
  isEdit = false,
}) => {
  return isCoordinator
    ? isReadOnly || isReadOnlyForCoordinator(appointmentType)
    : isReadOnly || isReadOnlyForRs(appointmentType, isEdit)
}
